export const ROUTES = {
  ROOT: "/",
  SEARCH: {
    HOMES: "/homes",
    BROKERS: "/brokers",
    /**
     * @deprecated
     * use SEARCH.SEPECULATORS
     */
    BUYERS: "/speculators",
    SPECULATORS: "/speculators",
    AREAS: "/areas",
    MUNICIPALITIES: "/municipalities",
    PLACES: "/places",
    PROJECTS: "/projects",
  },
  PROFILES: {
    HOMES: "/homes/",
    /**
     * @deprecated
     * use PROFILES.SEPECULATORS
     */
    BUYERS: "/speculators/",
    SPECULATORS: "/speculators/",
    SEARCHES: "/searches/",
    BROKERS: "/brokers/",
    AREAS: "/areas/",
    MUNICIPALITIES: "/municipalities/",
    PLACES: "/places/",
    PROJECTS: "/projects/",
  },
  /**
    * @deprecated
    * use SEARCH_SEPECULATORS
    */
  SEARCH_BUYERS: "/speculators/address/[addressId]",
  SEARCH_SPECULATORS: "/speculators/address/[addressId]",
  /**
    * @deprecated
    * use SEARCH_SEPECULATORS_PATH
    */
  SEARCH_BUYERS_PATH: "/speculators/address/",
  SEARCH_SPECULATORS_PATH: "/speculators/address/",
  /**
    * @deprecated
    * use SPECULATORS
    */
  BUYERS: "/speculators/[slug]",
  SPECULATORS: "/speculators/[slug]",
  BROKERS: "/brokers/[slug]",
  FEED: "/feed",
  BUY: "/buy",
  SELL: "/sell",
  TAGS: "/tag",
  STREET: "/street/[...streetWithCity]",
  CITY: "/city/[city]",
  ZIP: "/zip/[zip]",
  NEARBY: "/nearby/[...nearby]",
  CATEGORY: "/category/[...categories]",
  STATUS: "/status/[...statuses]",
  LOGIN: "/auth/login",
  CHAT: "/chat",
  CHAT_CONVERSATION: "/chat/[slug]",
  CHAT_CONVERSATION_PATH: "/chat/",
  CLAIM: "/claim",
  CLAIM_HOME: "/claim/[hash]",
  CLAIM_HOME_PATH: "/claim/",
  VERIFY: "/verify",
  VERIFY_PATH: "/verify/",
  CLIENT_PORTAL: "/mina-sidor", // EO-specific legacy route
  ANALYTICS: {
    INDEX: "/analytics",
    THIS_MONTH: "/analytics/thismonth",
  },
  CMS: {
    INDEX: "/p",
    ABOUT: "/p/about",
    HOW_IT_WORKS: "/p/how-it-works",
    PRIVACY: "/b/legal/privacy",
    TERMS: "/b/legal/terms",
    FAQ: "/p/faq",
  },
  EO_BLOG: {
    INDEX: "/b",
    POST: "/b/[category]/[slug]",
    // Legacy routes for backwards compatibility
    BOSTADSGUIDEN: {
      INDEX: "/b/bostadsguiden",
      CATEGORY: "/b/[category]",
      POST: "/b/[category]/[slug]",
    },
    MARKNADSKOMMENTAR: {
      INDEX: "/b/marknadskommentar",
      POST: "/b/marknadskommentar/[slug]",
    },
  },
  DASHBOARD: {
    INDEX: "/dashboard",
    ACCOUNT: "/dashboard/account",
    SELLER: {
      INDEX: "/dashboard/seller",
    },
    BUYER: {
      INDEX: "/dashboard/buyer",
      VIEW: "/dashboard/buyer/[id]",
      VIEW_PATH: "/dashboard/buyer/",
      EDIT: "/buy/edit/[id]",
      EDIT_PATH: "/buy/edit/",
    },
    SPECULATOR: {
      INDEX: "/dashboard/speculator",
      VIEW: "/dashboard/speculator/[id]",
      VIEW_PATH: "/dashboard/speculator/",
      EDIT: "/buy/edit/[id]",
      EDIT_PATH: "/buy/edit/",
    },
    BROKER: {
      INDEX: "/dashboard/broker",
    },
    HOMES: {
      INDEX: "/dashboard/homes",
      VIEW: "/dashboard/homes/[id]",
      VIEW_PATH: "/dashboard/homes/",
      /**
      * @deprecated
      * use HOMES.VIEW_SPECULATORS
      */
      VIEW_BUYERS: "/dashboard/homes/buyers/[id]",
      VIEW_SPECULATORS: "/dashboard/homes/speculators/[id]",
      /**
      * @deprecated
      * use HOMES.VIEW_SPECULATORS_PATH
      */
      VIEW_BUYERS_PATH: "/dashboard/homes/buyers/",
      VIEW_SPECULATORS_PATH: "/dashboard/homes/speculators/",
      EDIT: "/dashboard/homes/edit/[id]",
      EDIT_PATH: "/dashboard/homes/edit/",
    },
  },
};

export const PRIVATE_ROUTES = [ROUTES.CHAT, ROUTES.CLAIM, ROUTES.VERIFY];
